export default __webpack_public_path__ + "static/media/editgreen.2f504430.svg";